import type { Addresses } from 'api/types/addresses.types';

const RADIUS_OF_EARTH = 6378137; // in metens

const convertToRadians = (degrees: number) => degrees * (Math.PI / 180);

export const calculateDistance = (fromCoords: Addresses.Coordinates, toCoords: Addresses.Coordinates) => {
  const { lat: fromLat, lng: fromLong } = fromCoords;
  const { lat: toLat, lng: toLong } = toCoords;

  if (fromLong === toLong && fromLat === toLat) return 0;

  // converting the degrees to radians
  const fromLatRadins = convertToRadians(fromLat);
  const toLatRadians = convertToRadians(toLat);

  const theta = fromLong - toLong;
  const thetaRadians = convertToRadians(theta);

  const angle = Math.acos(
    Math.sin(fromLatRadins) * Math.sin(toLatRadians) + Math.cos(fromLatRadins) * Math.cos(toLatRadians) * Math.cos(thetaRadians)
  );

  // returns the value in meters
  return RADIUS_OF_EARTH * angle;
};
